import React, { ReactNode, useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import { handleSwipeLeft, handleSwipeRight } from './utils';
import { CarouselPage } from './types';
import Box from '@material-ui/core/Box';
import CarouselDots from './CarouselDots';

interface CarouselProps {
  pages: CarouselPage[];
  textBelowCarousel?: ReactNode[];
}

export function Carousel({ pages, textBelowCarousel = [] }: CarouselProps) {
  const [step, setStep] = useState<number>(0);

  const Page = pages[step]?.page;

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => handleSwipeLeft(pages.length, step, setStep),
    onSwipedRight: () => handleSwipeRight(step, setStep),
  });

  return (
    <>
      <Box
        display="flex"
        alignContent="center"
        justifyContent="center"
        {...swipeHandlers}
      >
        {Page}
      </Box>
      <CarouselDots {...{ pages, textBelowCarousel, step, setStep }} />
    </>
  );
}
